import Autosuggest from 'react-autosuggest';
import React, { Component } from 'react';
import { suggestionsFilter } from './suggestionsFilter';
import { filter, isEqual, sortBy } from 'lodash';
import './autocomplete.scss';

const getSuggestionValue = (suggestion) => suggestion;

// Use your imagination to render suggestions.
const renderSuggestion = (suggestion) => <div title={suggestion}>{suggestion}</div>;

export default class AutocompleteInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: null,
            filteredItems: [],
        };
    }
    shouldComponentUpdate(props, state) {
        return !isEqual(props, this.props) || !isEqual(state, this.state);
    }
    render() {
        let autosuggestProps = {
            inputProps: {
                className: 'form-control',
                value: this.props.value || '',
                onChange: this.handleChange.bind(this),
            },
            suggestions: this.state.filteredItems,
            onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested.bind(this),
            onSuggestionsClearRequested: this.handleSuggestionsClearRequested.bind(this),
            getSuggestionValue: getSuggestionValue,
            renderSuggestion: renderSuggestion,
            shouldRenderSuggestions: function () {
                return true;
            }.bind(this),
        };
        return <Autosuggest {...autosuggestProps} />;
    }
    handleSuggestionsFetchRequested(options) {
        // console.log(options);

        if (!this.state.items) {
            // console.log('FETCH ITEMS');
            this.props.fetchSuggestions().then(({ suggestions, save }) => {
                this.setState({
                    items: save ? suggestions : false,
                    filteredItems: parseSuggestions(suggestions, options.value),
                });
            });
        } else {
            // console.log('JUST UPDATE ITEMS');
            this.setState({
                filteredItems: parseSuggestions(this.state.items, options.value),
            });
        }
    }
    handleSuggestionsClearRequested() {
        this.setState({ filteredItems: [] });
    }
    handleChange(e, { newValue }) {
        this.props.onChange(newValue);
    }
}

function parseSuggestions(suggestions, value) {
    let result = filter(suggestions, suggestionsFilter.bind(this, value));

    result = sortBy(result, (str) => str.toLowerCase());

    return result;
}
